import { render, staticRenderFns } from "./MenuAdd.form.vue?vue&type=template&id=b192cdc4&"
import script from "./MenuAdd.form.vue?vue&type=script&lang=js&"
export * from "./MenuAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports